module.exports = __webpack_public_path__ + "static/media/Template-UPS.f8fe00eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/modules/channel/pages/Template-UPS.svg
// module id = 3727
// module chunks = 4